import config from "../../config";
import { apiFetch, createMultiConsumerGet } from "./apiFetch";
import { requestError } from "./requestError";


const getAccountId = () => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user.accountId;
};

const buildUrl = (path, params = {}) => {
    const filtered = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const qs = new URLSearchParams({ account_id: getAccountId(), ...filtered });
    return `${config.apiUrl}/${path}?${qs}`;
};

const postJson = async (path, body) => {
    const res = await apiFetch(`${config.apiUrl}/${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ account_id: getAccountId(), ...body }),
    });
    if (!res.ok) throw await requestError(res);
    return res.json();
};

const putJson = async (path, body) => {
    const res = await apiFetch(`${config.apiUrl}/${path}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ account_id: getAccountId(), ...body }),
    });
    if (!res.ok) throw await requestError(res);
    return res.json();
};

const del = async (path, params) => {
    const res = await apiFetch(buildUrl(path, params), { method: "DELETE" });
    if (!res.ok) {
        // Keep the server's reason (e.g. "…can't be deleted because … is linked to it.").
        throw await requestError(res);
    }
    return res.json();
};

const sharedGet = createMultiConsumerGet(async (url, options) => {
    const res = await apiFetch(url, options);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
});
const get = (path, params = {}, options = {}) => {
    const url = buildUrl(path, params);
    return sharedGet(url, options);
};

/* ════════════════════════════════════════════════════════════════
   PURCHASE ORDER
   ════════════════════════════════════════════════════════════════ */
export const getPurchaseOrders = (p = {}, options = {}) => get("getPurchaseOrders", p, options);
export const getApprovedPurchaseOrderMaterialQuantities = () => get("getApprovedPurchaseOrderMaterialQuantities");
export const getPurchaseOrderKpis = () => get("getPurchaseOrderKpis");
export const getPurchaseOrderById = (id, options = {}) => get("getPurchaseOrderById", { id }, options);
export const createPurchaseOrder = (data) => postJson("createPurchaseOrder", data);
export const updatePurchaseOrder = (id, data) => putJson("updatePurchaseOrder", { id, ...data });
export const deletePurchaseOrder = (id) => del("deletePurchaseOrder", { id });

/* ════════════════════════════════════════════════════════════════
   PURCHASE INVOICE
   ════════════════════════════════════════════════════════════════ */
export const getPurchaseInvoices = (p = {}, options = {}) => get("getPurchaseInvoices", p, options);
export const getPurchaseInvoiceById = (id, options = {}) => get("getPurchaseInvoiceById", { id }, options);
export const createPurchaseInvoice = (data) => postJson("createPurchaseInvoice", data);
export const updatePurchaseInvoice = (id, data) => putJson("updatePurchaseInvoice", { id, ...data });
export const deletePurchaseInvoice = (id) => del("deletePurchaseInvoice", { id });
export const getDirectPurchaseInvoices = (p = {}, options = {}) => get("getPurchaseInvoices", { ...p, piType: "Direct" }, options);
export const getIndirectPurchaseInvoices = (p = {}, options = {}) => get("getPurchaseInvoices", { ...p, piType: "Indirect" }, options);
export const getDirectPIKpis = () => get("getPurchaseInvoiceKpis", { piType: "Direct" });
export const getIndirectPIKpis = () => get("getPurchaseInvoiceKpis", { piType: "Indirect" });